import React from "react";
import type { TypePartnerLogoProps } from "./PartnerLogoTypes";
import PartnerLogoHybrid from "./PartnerLogoHybrid";

/**
 * PartnerLogo component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or styled() extension).
 */
const PartnerLogo = React.forwardRef<HTMLSpanElement, TypePartnerLogoProps>(
  (props, ref) => <PartnerLogoHybrid {...props} ref={ref} />
);

PartnerLogo.displayName = "PartnerLogo";
export default PartnerLogo;
